export const HOST = 'https://dev-web-api.newssalad.com';
export const ADMIN = 'https://dev-web-api.newssalad.com';